const dataNivel = [
 {   
    "id_nivel": 1,
    "nivel": "Doctorado",
},{   
    "id_nivel": 3,
    "nivel": "Maestría",
},{   
    "id_nivel": 2,
    "nivel": "Especialidad",
}

]
export default dataNivel;